import { c as _c } from "react/compiler-runtime";
import type { MemberLogoutResponse } from '@module/apis/client-side/member/type';
import { syncLoginInfoQueryData } from '@module/helpers/auth/syncLoginInfoQueryData';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import useSendAuthBC from '@module/helpers/auth/useSendAuthBC';
import { aspCond } from '@module/helpers/conditions/condition';
import { createSafeLocalStorage } from '@module/lib/storage/safe-local-storage';
import { autoLoginSafeLocalStorage, saveIdSafeLocalStorage, snsLoginInfoSafeLocalStorage, userIdSafeLocalStorage, userPwSafeLocalStorage } from '@module/lib/storage/storageImplementations';
import { useMemberLogoutMutation } from '@module/queries/member/memberQueryHooks';
import { INVALIDATION_EXCEPTION_QUERY_KEYS_ON_LOGOUT } from '@module/queries/member/memberQueryKeys';
import useModalStore from '@module/stores/useModalStore';
import catchAllErrors from '@module/utils/catchAllErrors';
import useGoPlay from '@pc/hooks/play/useGoPlay';
import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import type React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { AllMenu } from './after/Allmenu';
import AfterASPMenuItems from './after/ASPAfterMenuItems';
import MenuContext from './after/all/MenuContext';
import { FavoriteMenu } from './after/FavoriteMenu';
import UserCoinsMenuItem from './after/UserCoinsMenuItem';
import UserInfo from './after/UserInfo';
export type F_Select = {
  title: string;
  img: string;
  url: string;
};
export const initMyListfunc = (id?: string) => {
  return [{
    title: '마이페이지',
    img: 'MyMenuMypage',
    url: '/my/modify',
    type: 'my'
  }, {
    title: '결제내역',
    img: 'MyMenuPayDetail',
    url: '/my/payment/pay',
    type: 'my'
  }, {
    title: '아이템내역',
    img: 'MyMenuItemDetail',
    url: '/my/item/used',
    type: 'my'
  }, {
    title: '선물내역',
    img: 'MyMenuGiftDetail',
    url: '/my/gift/received',
    type: 'my'
  }, {
    title: '미션내역',
    img: 'MyMenuMissionlist',
    url: '/my/mission',
    type: 'my'
  }, {
    title: 'VIP 시그니처',
    img: 'MyMenuSignature',
    url: '/my/signatureUser',
    type: 'my'
  }, {
    title: '쿠폰등록',
    img: 'MyMenuCouponUp',
    url: '',
    type: 'my'
  }, {
    title: '채널 홈',
    img: 'MyMenuChannelHome',
    url: `/channel/${id}/home/member`,
    type: 'chnnel'
  }, {
    title: '환전',
    img: 'MyMenuExchange',
    url: `/channel/${id}/exchange/apply`,
    type: 'chnnel'
  }, {
    title: '이벤트',
    img: 'MyMenuEvent',
    url: '/customer/event',
    type: 'customer'
  }, {
    title: '공지사항',
    img: 'MyMenuNotice',
    url: '/customer/notice',
    type: 'customer'
  }, {
    title: '무료하트',
    img: 'MyMenuAdhart',
    url: '/customer/freeCoin/1',
    type: 'customer'
  }, {
    title: '자주하는질문',
    img: 'MyMenuFaq',
    url: '/customer/faq',
    type: 'customer'
  }, {
    title: '방송가이드',
    img: 'MyMenuBroadcastGuide',
    url: '/customer/guide/pc/external',
    type: 'customer'
  }, {
    title: '1:1문의',
    img: 'MyMenuAsk',
    url: '/customer/inquire',
    type: 'customer'
  }, {
    title: '신고센터',
    img: 'MyMenuReportCenter',
    url: '/customer/claim/illegalDistribution',
    type: 'customer'
  }];
};
export function AfterItem() {
  const $ = _c(40);
  const queryClient = useQueryClient();
  const route = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [selectList, setSelectList] = useState(t0);
  const pushModal = useModalStore(_temp);
  const {
    sendLogoutMessage
  } = useSendAuthBC();
  const {
    isAdult,
    userInfo
  } = useGetLoginInfoQuery();
  const {
    refetchPlayInfoIfPlayPage
  } = useGoPlay();
  let t1;
  if ($[1] !== userInfo?.id) {
    t1 = type => {
      const initMyList = initMyListfunc(userInfo?.id);
      return initMyList.filter(el => el.type === type);
    };
    $[1] = userInfo?.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const initMyListHandler = t1;
  const t2 = `myMenuList-${userInfo?.idx}`;
  let t3;
  if ($[3] !== t2) {
    t3 = createSafeLocalStorage(t2, []);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const myMenuListSafeLocalStorage = t3;
  let t4;
  if ($[5] !== queryClient || $[6] !== refetchPlayInfoIfPlayPage || $[7] !== sendLogoutMessage) {
    t4 = logoutResponse => {
      sendLogoutMessage();
      syncLoginInfoQueryData(queryClient, logoutResponse.loginInfo);
      queryClient.invalidateQueries({
        predicate: _temp2
      });
      refetchPlayInfoIfPlayPage();
      autoLoginSafeLocalStorage.set(false);
      if (saveIdSafeLocalStorage.get()) {
        userIdSafeLocalStorage.remove();
      }
      userPwSafeLocalStorage.remove();
      snsLoginInfoSafeLocalStorage.remove();
    };
    $[5] = queryClient;
    $[6] = refetchPlayInfoIfPlayPage;
    $[7] = sendLogoutMessage;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleLogoutSuccess = t4;
  let t5;
  if ($[9] !== handleLogoutSuccess) {
    t5 = {
      onSuccess: handleLogoutSuccess,
      onError: _temp3
    };
    $[9] = handleLogoutSuccess;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const {
    mutate: logout
  } = useMemberLogoutMutation(t5);
  let t6;
  if ($[11] !== myMenuListSafeLocalStorage || $[12] !== userInfo?.id || $[13] !== userInfo?.idx) {
    t6 = () => {
      if (!userInfo?.idx) {
        return;
      }
      const data = myMenuListSafeLocalStorage.get();
      if (data) {
        for (const element of data) {
          const myList = initMyListfunc(userInfo?.id);
          const findItem = myList.find(f => f.title === element);
          if (findItem) {
            setSelectList(prev => [...prev, findItem]);
          }
        }
      }
    };
    $[11] = myMenuListSafeLocalStorage;
    $[12] = userInfo?.id;
    $[13] = userInfo?.idx;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== userInfo) {
    t7 = [userInfo];
    $[15] = userInfo;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  useEffect(t6, t7);
  let t8;
  if ($[17] !== myMenuListSafeLocalStorage || $[18] !== selectList) {
    t8 = () => {
      if (typeof window === "undefined") {
        return;
      }
      myMenuListSafeLocalStorage.set(selectList.map(_temp4));
    };
    $[17] = myMenuListSafeLocalStorage;
    $[18] = selectList;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== selectList) {
    t9 = [selectList];
    $[20] = selectList;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  useEffect(t8, t9);
  let t10;
  if ($[22] !== logout || $[23] !== pushModal || $[24] !== route) {
    t10 = item => {
      if (item.title === "\uCFE0\uD3F0\uB4F1\uB85D") {
        pushModal({
          type: "ADD_COUPON_MODAL",
          id: "AfterItem"
        });
      } else {
        if (item.title === "\uC678\uBD80\uC571\uBC29\uC1A1\uD558\uAE30") {
          window.open("/setting/broadcast", "popupView", "width=432,height=768");
        } else {
          if (item.title === "\uB85C\uADF8\uC544\uC6C3") {
            logout();
          } else {
            route.push(item.url);
          }
        }
      }
    };
    $[22] = logout;
    $[23] = pushModal;
    $[24] = route;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const navigateHandler = t10;
  let t11;
  if ($[26] !== pushModal || $[27] !== selectList) {
    t11 = (e, el_0) => {
      e.stopPropagation();
      const sameIndex = selectList.findIndex(f_1 => f_1.title === el_0.title);
      const assignList = [...selectList];
      if (sameIndex !== -1) {
        assignList.splice(sameIndex, 1);
        setSelectList(assignList);
      } else {
        if (selectList.length === 5) {
          pushModal({
            type: "CONFIRM_MODAL",
            id: "AfterItem",
            options: {
              description: "\uC990\uACA8\uCC3E\uAE30\uB294 5\uAC1C\uAE4C\uC9C0 \uC124\uC815\uAC00\uB2A5\uD569\uB2C8\uB2E4."
            }
          });
        } else {
          const assingList = [...selectList];
          assingList.unshift(el_0);
          setSelectList(assingList);
        }
      }
    };
    $[26] = pushModal;
    $[27] = selectList;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  const addItemHandler = t11;
  let t12;
  if ($[29] !== addItemHandler || $[30] !== initMyListHandler || $[31] !== isAdult || $[32] !== navigateHandler || $[33] !== selectList || $[34] !== userInfo) {
    t12 = {
      navigateHandler,
      addItemHandler,
      selectList,
      setSelectList,
      isAdult,
      userInfo,
      initMyListHandler
    };
    $[29] = addItemHandler;
    $[30] = initMyListHandler;
    $[31] = isAdult;
    $[32] = navigateHandler;
    $[33] = selectList;
    $[34] = userInfo;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  const contextValue = t12;
  let t13;
  let t14;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <UserInfo />;
    t14 = <UserCoinsMenuItem />;
    $[36] = t13;
    $[37] = t14;
  } else {
    t13 = $[36];
    t14 = $[37];
  }
  let t15;
  if ($[38] !== contextValue) {
    t15 = <div className="bg-colorBg14">{t13}{t14}{aspCond.if("asp") ? <AfterASPMenuItems /> : <MenuContext.Provider value={contextValue}><FavoriteMenu /><AllMenu /></MenuContext.Provider>}</div>;
    $[38] = contextValue;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  return t15;
}
function _temp4(f_0) {
  return f_0.title;
}
function _temp3(error) {
  return catchAllErrors(error);
}
function _temp2(key) {
  return !INVALIDATION_EXCEPTION_QUERY_KEYS_ON_LOGOUT.some(excludedKey => key.queryKey.includes(excludedKey));
}
function _temp(state) {
  return state.pushModal;
}